import axios from 'axios';
import { ORDER_GROUP_STATUSES } from '../constants/appConstants';

export const ORDERS_FILTER_PREF_KEYS = {
  statusFilter: 'orders_statusFilter',
};

const ALL_GROUP_STATUSES = Object.values(ORDER_GROUP_STATUSES);

export function pickOrdersStatusFilterFromPrefs(prefs, defaultStatuses = []) {
  const raw = prefs?.[ORDERS_FILTER_PREF_KEYS.statusFilter];
  if (!Array.isArray(raw)) return [...defaultStatuses];
  const valid = raw.filter((s) => ALL_GROUP_STATUSES.includes(s));
  return valid;
}

/** Default status filter before user preferences load (staff orders page only). */
export function resolveDefaultOrdersStatusFilter(isInternal, clientId) {
  return isInternal && !clientId ? [ORDER_GROUP_STATUSES.OPEN] : [];
}

export async function saveOrdersStatusFilterPreference(statuses) {
  const value = (statuses || []).filter((s) => ALL_GROUP_STATUSES.includes(s));
  await axios.put('/api/users/preferences', {
    key: ORDERS_FILTER_PREF_KEYS.statusFilter,
    value,
  });
}
